import { ReactNode, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { LucideIcon } from 'lucide-react';
import { AdminSidebar } from './AdminSidebar';
import { AdminTopbar } from './AdminTopbar';
import { ADMIN_NAV_SECTIONS } from '../../../config/adminNavigation';

interface AdminLayoutProps {
  children: ReactNode;
  title?: string;
  description?: string;
  action?: {
    label: string;
    icon: LucideIcon;
    onClick: () => void;
  };
}

export function AdminLayout({ children, title, description, action }: AdminLayoutProps) {
  const location = useLocation();
  const [pageTitle, setPageTitle] = useState(title || 'Tableau de bord');
  const [pageDescription, setPageDescription] = useState(description);

  useEffect(() => {
    if (title) return;

    for (const section of ADMIN_NAV_SECTIONS) {
      const item = section.items.find(i => i.path === location.pathname);
      if (item) {
        setPageTitle(item.label);
        break;
      }
    }
  }, [location.pathname, title]);

  return (
    <div className="min-h-screen bg-gray-50">
      <AdminSidebar />

      <div className="pl-64">
        <AdminTopbar title={pageTitle} description={pageDescription} action={action} />

        <main className="p-6">
          {children}
        </main>
      </div>
    </div>
  );
}
